import React, { useContext, useMemo } from "react";
import FormulaGenerator from "../../../FormulaGenerator";
import "./index.scss";
import { getAvailableSidesByStep } from "../../../FormulaGenerator/formulaHelpers";
import { getStepInfo } from "../../stepInfo";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const ExtraVeneersSelect = ({
  stepId,
  toggleNextBtnState
}) => {
  const {
    language
  } = useTranslation();
  const {
    dentalData,
    setStepFormula
  } = useContext(StepContext);

  function setData(data) {
    setStepFormula(stepId, data);
    toggleNextBtnState(false);
  }

  const availableSwitchers = useMemo(() => {
    return getAvailableSidesByStep(stepId);
  }, [stepId]);
  const formulaHelperText = useMemo(() => {
    return getStepInfo(language, stepId)?.formulaHelperText || "";
  }, [language, stepId]);
  return /*#__PURE__*/React.createElement("div", {
    className: "extraVeneersSelect"
  }, /*#__PURE__*/React.createElement(FormulaGenerator, {
    projectData: dentalData,
    setProjectDentalData: setData,
    initialSelection: "extraVeneersSelect",
    availableSwitchers: availableSwitchers,
    formulaHelperText: formulaHelperText
  }));
};

export default ExtraVeneersSelect;